var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.069 13.5262H26.1818L26.9634 12.0215H38.069C40.6451 12.0215 42.7335 14.1099 42.7335 16.6861V32.6359C42.7335 35.2121 40.6451 37.3005 38.069 37.3005H21.3668L22.2696 35.7958H38.069C39.8141 35.7958 41.2288 34.3811 41.2288 32.6359V16.6861C41.2288 14.9409 39.8141 13.5262 38.069 13.5262Z",
    fill: "#D1112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 35.7958H4.66458C2.91943 35.7958 1.5047 34.3811 1.5047 32.6359V16.6861C1.5047 14.9409 2.91943 13.5262 4.66458 13.5262H20.1765L21.0884 12.0215H4.66458C2.0884 12.0215 0 14.1099 0 16.6861V32.6359C0 35.2121 2.0884 37.3005 4.66458 37.3005H16.5517L17.4545 35.7958Z",
    fill: "#D1112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7891 18.793H44.09C46.2507 18.793 48.0022 20.5445 48.0022 22.7052V26.3165C48.0022 28.4771 46.2507 30.2287 44.09 30.2287H43.7891V18.793Z",
    fill: "#D1112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 26.6178L24.6721 10.668L21.6627 22.4046H30.2395L18.6533 37.7526L21.9637 26.6178H13.0859Z",
    fill: "#D1112B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLogo);
export default __webpack_public_path__ + "static/media/batteryLogo.003a5c36312001e35fc3bb09bcfe307b.svg";
export { ForwardRef as ReactComponent };